module.exports = __webpack_public_path__ + "static/media/azerbeidzan-small.932e1ba2.jpg";